export default "__VITE_ASSET__CLaVQUth__"